import { bind } from '@react-rxjs/core'

import { right } from '../../utils/result'
import { mapRight } from '../../utils/rx/operators'
import { latestDispensaryBySlugCdn$ } from './query'

export const [useDispensaryContact, latestDispensaryContact$] = bind(
  latestDispensaryBySlugCdn$.pipe(mapRight((result) => right(result.data?.contact ?? null))),
)
